import { Component, EventEmitter, HostListener, inject, Input, Output, signal } from '@angular/core';
import { SubscriptionService } from '../../services/subscription/subscription.service';
import { ChoosePlanService } from '../choose-plan/service/choose-plan/choose-plan.service';
import { HasBoltOnDirectiveDirective } from "../../common/directives/has-bolt-on/has-bolt-on-directive.directive";
import { environment } from "../../../environments/environment";
import { NotHasBoltOnDirectiveDirective } from "../../common/directives/not-has-bolt-on/not-has-bolt-on-directive.directive";
import { BriefService } from '../../services/brief/brief.service';
import { ToastNotificationService } from '../../atoms/toast-notification/toast-notification.service';
import { ViewportOverlayDirective } from '../../common/directives/viewport-overlay/viewport-overlay.directive';

@Component({
  selector: 'app-choose-auto-pilot',
  standalone: true,
  imports: [HasBoltOnDirectiveDirective, NotHasBoltOnDirectiveDirective],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './choose-auto-pilot.component.html',
  styleUrl: './choose-auto-pilot.component.css'
})
export class ChooseAutoPilotComponent {

  environment = environment;

  @Input() briefId!: string;

  @Output() refreshBriefOut = new EventEmitter<void>(); 

  constructor() {
    
  }

  howItWorks: { step: number, description: string }[] = [
    { step: 1, description: 'Add moderation rules and creator criteria to your brief' },
    { step: 2, description: 'Matching creators are hired automatically' },
    { step: 3, description: 'Outreach, briefing, and follow-up are handled for you' },
    { step: 4, description: 'Content that meets your rules is approved' },
  ]

  features: { id: number, title: string, description: string }[] = [
    { id: 1, title: 'Skip the shortlist', description: 'Only creators who match your viability rules get hired.' },
    { id: 2, title: 'Stay out of the thread', description: "Creators still get briefed and chased — you don't write every message." },
    { id: 3, title: 'Approve by exception', description: 'Passing content is signed off automatically. Failures come back to you.' },
    { id: 4, title: 'Stay on budget', description: "Spend never goes past the cap you set for this brief." },
  ]

  toggleLoading = signal<boolean>(false);

  /** Services */
  private choosePlanService = inject(ChoosePlanService);
  public subscriptionService = inject(SubscriptionService);
  private briefService = inject(BriefService);
  private toastNotificationService = inject(ToastNotificationService);
  /** Services END */

  @HostListener('document:keydown.escape')
  onEscape() {
    this.closeModal();
  }

  toggleAutoPilot() {
    console.log('toggleAutoPilot()');
    this.toggleLoading.set(true);
    this.briefService.toggleAutoPilot(this.briefId).subscribe({
      next: (response) => {
        console.log('Toggle Auto Pilot Response: ', response);
        this.toggleLoading.set(false);
        this.toastNotificationService.alert({
          title: 'Auto Pilot Enabled!',
          message: 'Auto Pilot has been enabled successfully.',
          type: 'success',
          icon: 'success'
        }); 
        this.closeModalAndRefresh();
      },
      error: (error) => {
        console.error('error', error);
        this.toggleLoading.set(false);
      }
    });
  }

  openChoosePlan() {
    console.log('openChoosePlan()');
    this.choosePlanService.launchSubscribeOrBoltOn(environment.stripe.shaas21products.bo_ai_moderation);
    this.closeModal();
  }

  closeModal() {
    this.choosePlanService.autoPilotModalOpen.set(undefined);
  }

  closeModalAndRefresh() {
    this.refreshBriefOut.emit();
    this.closeModal();
  }
}
